/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2023. All Rights Reserved.
#*
#*===================================================================
*/

import { TenantApiManagementConfigDTO } from '@client-details/api-management/shared';
import { createAction, props } from '@ngrx/store';

export const loadApiConfgis = createAction('[Client Details:Api Management] Load Api Management Configs');
export const loadApiConfgisSuccess = createAction(
  '[Client Details:Api Management] Load Api Management Configs Sucess',
  props<{ configs: TenantApiManagementConfigDTO[] }>()
);

export const openDialiog = createAction(
  '[Client Details:Api Management] Open Dialog',
  props<{
    configs: TenantApiManagementConfigDTO[];
    edit: boolean;
    config: Partial<TenantApiManagementConfigDTO> | null;
  }>()
);

export const createConfig = createAction(
  '[Client Details:Api Management] Create Config',
  props<{ config: Partial<TenantApiManagementConfigDTO> }>()
);
export const createConfigSuccess = createAction(
  '[Client Details:Api Management] Create Config Success',
  props<{ config: TenantApiManagementConfigDTO }>()
);

export const updateConfig = createAction(
  '[Client Details:Api Management] Update Config',
  props<{ config: Partial<TenantApiManagementConfigDTO> }>()
);
export const updateConfigSuccess = createAction(
  '[Client Details:Api Management] Update Config Success',
  props<{ config: TenantApiManagementConfigDTO }>()
);

export const deleteConfig = createAction('[Client Details:Api Management] Delete Config', props<{ id: number }>());
export const deleteConfigSuccess = createAction(
  '[Client Details:Api Management] Delete Config Success',
  props<{ id: number }>()
);

export const failure = createAction('[Client Details:Api Management] Failure', props<{ errorMessage: string }>());
